import { useContext, useState } from "react";
import { useFormik } from "formik";
import FormLabel from "../../../UI/Form/FormLabel";
import ButtonLoading from "../../../UI/Button/ButtonLoading";
import Alert from "../../../UI/Alert/Alert";
import { NotifyContext } from "../../../context/notifyContext";
import UserAPI from "../../../services/api/UserService";
import { Parent } from "../../../Types/Users";

interface AcceptParentProps {
  onClose?: () => void;
  parent?: Parent | null;
}

export default function AcceptParent(props: AcceptParentProps) {
  const { parent } = props;

  const notify = useContext(NotifyContext);

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
    },
    onSubmit: () => {
      setLoading(true);
      if (parent)
        UserAPI.confirm_user(parent.user_id)
          .then((data) => {
            notify("Vous avez confirmé le parent");
            setError("");
            if (props.onClose) {
              props.onClose();
            }
          })
          .catch((error) => {
            setError(error);
            notify(error, "error");
          })
          .finally(() => {
            setLoading(false);
          });
    },
  });

  return (
    <div>
      <form className="px-4 py-3" onSubmit={formik.handleSubmit}>
        {error && <Alert color="error">{error}</Alert>}

        <div className={`mt-6 `}>
          <FormLabel htmlFor="title">
            Voulez-vous confirmer{" "}
            <strong>
              {parent?.first_name} {parent?.last_name}
            </strong>{" "}
            comme parent ?
          </FormLabel>
        </div>

        <ButtonLoading
          type="submit"
          loading={loading}
          label="Je confirme !"
          className="mt-4"
        />
      </form>
    </div>
  );
}
